import { Route, Switch } from "react-router-dom";
import PortariaListagemPage from "./Listagem";

function PortariaPages() {
  return (
    <Switch>
      <Route exact path="/administracao/portaria" component={PortariaListagemPage} />
    </Switch>
  );
}

export default PortariaPages;